import Vue from 'vue';
import { SNACKBAR_SHOW, CONFIRM_SHOW } from '@/store/mutation-types.js';

Vue.mixin({
  data() {
    return {
      publicPath: process.env.BASE_URL
    };
  },
  methods: {
    getModule(stateName) {
      return this.$store.getters.getModule(stateName);
    },
    getState(stateName) {
      return this.$store.getters.getState(stateName);
    },
    setState(stateName, value) {
      return this.$store.getters.setState(stateName, value);
    },
    isRoute(name) {
      if(Array.isArray(name)) {
        return name.indexOf(this.$router.currentRoute.name) != -1;
      } else {
        return this.$router.currentRoute.name == name;
      }
    },
    isNotRoutes(routes) {
      return routes.indexOf(this.$router.currentRoute.name) == -1;
    },
    getUser(userId) {
      return this.$store.getters.getUser(userId);
    },
    stopLoading() {
      this.$store.state.toggle.loading = false
    },
    showLoading() {
      this.$store.state.toggle.loading = true
    },
    // alert(message, title) {
    //
    // },
    // confirm(message, title) {
    //
    // },
    // success(message) {
    //
    //   // SNACKBAR_SHOW
    // },
    // error(message) {
    //
    // }
    successMessage(message) {
      this.$store.commit(SNACKBAR_SHOW, {
        x: 'right',
        y: 'bottom',
        text: message,
        color: 'success',
      });
    },
    errorMessage(message) {
      this.$store.commit(SNACKBAR_SHOW, {
        x: 'right',
        y: 'bottom',
        text: message,
        color: 'error',
      });
    },
    handleError(e) {
      console.log(e);
      let message = e;

      if (typeof (e.response) !== "undefined" &&
        typeof (e.response.data) !== "undefined" &&
        typeof (e.response.data.error) !== "undefined" &&
        typeof (e.response.data.error.message) !== "undefined"
      ) {
        message = e.response.data.error.message
      }

      this.$store.commit(SNACKBAR_SHOW, {
        x: 'right',
        y: 'bottom',
        text: message,
        color: 'error',
      });
    },
    alertMessage() {
      // @todo: change to alert modal.
      this.$store.commit(SNACKBAR_SHOW, {
        x: 'right',
        y: 'bottom',
        text: message,
        color: 'error',
      });
    },
    confirm(message) {
      return this.$store.dispatch('confirmShow', {
        message
      })
    }
  }
});
